// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';

import "./styles/Home.css"
import { useRef } from 'react';

import banner1 from './assets/images/banner_gps.png'; //'./assets/images/mapa_teste.png';//
import banner2 from './assets/images/banner_taxavar.png';
import banner3 from './assets/images/banner_taxafixa.png';
import banner4 from './assets/images/banner_telemetria.png';

function Home() {
  //Site do carousel https://swiperjs.com/demos
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };
  return (
    <>
      <Swiper
        spaceBetween={30}
        effect={'slide'}
        fadeEffect={{ crossFade: true }}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,    // mobile-friendly
        }}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={banner1} alt='' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={banner2} alt='' />
          </SwiperSlide>
        <SwiperSlide>
          <img src={banner3} alt='' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={banner4} alt='' />
        </SwiperSlide>
        <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
      </Swiper>
    </>
  );
}

export default Home;
